function isMobileUserAgent() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}
function pickInitialLevel(effectiveType, downlink) {
  if (downlink > 0) {
    if (downlink >= 2.5) {
      return -1;
    } else if (downlink >= 1) {
      return 1; // 480p
    } else {
      return 0; // 270p
    }
  } else {
    if (effectiveType === '3g' || effectiveType === '2g' || effectiveType === 'slow-2g') {
      return 0; // 270p - default fallback
    } else if (effectiveType === '4g') {
      return -1; // 720p
    }
  }
  return -1; // use auto level
}
export function getInitialLevel() {
  const nav = navigator;
  const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
  if (!connection) {
    // For browsers like Safari that don't support the Network Information API,
    // only start with lowest quality for mobile users. Desktop users should use auto level.
    if (isMobileUserAgent()) {
      return 0; // 270p - default fallback for mobile
    }
    return -1; // use auto level for desktop
  }
  const effectiveType = connection.effectiveType;
  const downlink = connection.downlink;
  return pickInitialLevel(effectiveType, downlink);
}